
//Regex perzonalizados para capturar y entender las respuestas del agente principal

// Regex para detectar el tipo de respuesta 'voice_message'
export const VOICE_MESSAGE_RESPONSE_TYPE_REGEX = /"response_type"\s*:\s*"voice_message"\s*,\s*"voice_message"\s*:\s*"/i;
export const VOICE_MESSAGE_RESPONSE_FOR_USER = /"\s*, \s*"voice_message"\s*:\s*"(.*?)/;
export const OUT_VOICE_MESSAGE_RESPONSE_FOR_USER = /",/;

// Regex para detectar el tipo de respuesta 'extracted_apis'
export const EXTRACTED_APIS_RESPONSE_REGEX = /"response_type"\s*:\s*"extracted_apis"/i;

// Regex para capturar la estructura completa de 'voice_message'
export const FULL_VOICE_MESSAGE_STRUCTURE_REGEX = /"voice_message": "(.*?)"/;
//export const FULL_VOICE_MESSAGE_STRUCTURE_REGEX = /\{[\s\S]*"response_type"\s*:\s*"voice_message"[\s\S]*"voice_message"\s*:\s*"([^"]*)"[\s\S]*\}/i;

// Regex para capturar la estructura completa de 'extracted_apis'
export const FULL_EXTRACTED_APIS_STRUCTURE_REGEX =  /"extracted_apis":\s*\[(.*?)]/;
//export const FULL_EXTRACTED_APIS_STRUCTURE_REGEX = /\{[\s\S]*"response_type"\s*:\s*"extracted_apis"[\s\S]*"extracted_apis"\s*:\s*\[[^\]]*\][\s\S]*\}/i;

// Regex para validar el formato de un elemento dentro de 'extracted_apis'
export const API_FORMAT_REGEX = /^\/mkg\/[a-z_]+\/$/;

// Regex para detectar matrículas de vehículos para su posterior conversión (ej. a mayúsculas).
// Admite formatos como AAA1234, AAA-1234, AAA1A34 y AAA-1A34, sin distinguir mayúsculas/minúsculas.
export const VEHICLE_PLATE_REGEX = /\b(?:[A-Za-z]{3}-?\d{4}|[A-Za-z]{3}-?\d[A-Za-z]\d{2})\b/g;

